export const TAG_LIST_REQUEST = 'TAG_LIST_REQUEST'
export const TAG_LIST_SUCCESS = 'TAG_LIST_SUCCESS'
export const TAG_LIST_FAILURE = 'TAG_LIST_FAILURE'

export const TAG_CREATE_REQUEST = 'TAG_CREATE_REQUEST'
export const TAG_CREATE_SUCCESS = 'TAG_CREATE_SUCCESS'
export const TAG_CREATE_FAILURE = 'TAG_CREATE_FAILURE'
export const TAG_CREATE_MODAL_OPEN = 'TAG_CREATE_MODAL_OPEN'
export const TAG_CREATE_MODAL_CLOSE = 'TAG_CREATE_MODAL_CLOSE'

export const TAG_DELETE_REQUEST = 'TAG_DELETE_REQUEST'
export const TAG_DELETE_SUCCESS = 'TAG_DELETE_SUCCESS'
export const TAG_DELETE_FAILURE = 'TAG_DELETE_FAILURE'
export const TAG_DELETE_MODAL_OPEN = 'TAG_DELETE_MODAL_OPEN'
export const TAG_DELETE_MODAL_CLOSE = 'TAG_DELETE_MODAL_CLOSE'